/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BusinessSettingsMainPageComponent} from './component/business-settings-main-page.component';
import {TableModule} from '../../../shared/table/table.module';
import {BusinessSettingsModule} from '../business-settings-tree/business-settings.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {InputModule} from '../../../shared/input/input.module';
import {BusinessSettingsModalModule} from './modals/business-settings-modal.module';
import {PaginationModule} from '../../../shared/pagination/pagination.module';
import {PathAlertsModule} from '../../../shared/path-alerts/path-alerts.module';

@NgModule({
    declarations: [BusinessSettingsMainPageComponent],
    imports: [
        CommonModule,
        TableModule,
        BusinessSettingsModule,
        LoadingSpinnerModule,
        InputModule,
        BusinessSettingsModalModule,
        PaginationModule,
        PathAlertsModule
    ]
})
export class BusinessSettingsMainPageModule {
}
